import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Landing } from './pages/Landing';
import { ThankYou } from './pages/ThankYou';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3ka4cx7exmllz">
      <div className="min-h-full w-full bg-white" data-id="element-1" data-mp="3k8jh7egvswmj">
        <Routes data-id="element-2" data-mp="3k78dfenfrovf">
          <Route path="/" element={<Landing data-id="element-4" data-mp="3fa84mvz7c80m" />} data-id="element-3" data-mp="3fargbuy9e067" />
          <Route path="/thank-you" element={<ThankYou data-id="element-6" data-mp="3f8n9p58z6n28" />} data-id="element-5" data-mp="3fb155f7ki1ab" />
        </Routes>
      </div>
    </BrowserRouter>;
}